<template>
  <div class="home">
    <div class="bg-decoration">
      <div class="cloud cloud-1"></div>
      <div class="cloud cloud-2"></div>
      <div class="cloud cloud-3"></div>
      <div class="cloud cloud-4"></div>
      <div class="wave wave-1"></div>
      <div class="wave wave-2"></div>
    </div>

    <div class="content">
      <h1 class="title">筋斗云</h1>
      <p class="subtitle">入境申报管理平台</p>

      <div class="entries">
        <div
          class="entry-card team"
          :class="{ 'is-clicked': isTeamClicked }"
          @click="handleClick('/team')"
        >
          <div class="card-bg"></div>
          <div class="card-content">
            <div class="icon-wrapper">
              <i class="fa-solid fa-people-group"></i>
            </div>
            <div class="text">
              <span class="entry-title">团队入口</span>
              <span class="entry-desc">进行团队申报</span>
            </div>
            <div class="arrow">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>
        </div>

        <div
          class="entry-card traveler coming-soon"
        >
          <div class="card-bg"></div>
          <div class="coming-soon-badge">敬请期待</div>
          <div class="card-content">
            <div class="icon-wrapper">
              <i class="fa-solid fa-person"></i>
            </div>
            <div class="text">
              <span class="entry-title">旅客入口</span>
              <span class="entry-desc">个人行程规划</span>
            </div>
            <div class="arrow">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <span>© 2026 筋斗云</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Home",
  setup() {
    const router = useRouter();
    const isTeamClicked = ref(false);

    const handleClick = (path: string) => {
      if (path === "/team") {
        isTeamClicked.value = true;
        setTimeout(() => {
          router.push(path);
        }, 300);
      }
    };

    return { handleClick, isTeamClicked };
  },
});
</script>

<style scoped>
.home {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(180deg, #e8f4fc 0%, #d4e9f7 30%, #f0f6fa 70%, #fafcfd 100%);
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.cloud {
  position: absolute;
  opacity: 0.7;
}

.cloud-1 {
  top: 5%;
  left: 10%;
  width: 280px;
  height: 100px;
  background: radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.95) 0%, transparent 70%);
  animation: cloudDrift 20s linear infinite;
}

.cloud-2 {
  top: 12%;
  right: 5%;
  width: 220px;
  height: 80px;
  background: radial-gradient(ellipse at 70% 50%, rgba(255,255,255,0.9) 0%, transparent 70%);
  animation: cloudDrift 25s linear infinite reverse;
}

.cloud-3 {
  top: 25%;
  left: 50%;
  width: 180px;
  height: 60px;
  background: radial-gradient(ellipse at 50% 50%, rgba(255,255,255,0.85) 0%, transparent 70%);
  animation: cloudDrift 18s linear infinite;
  animation-delay: -6s;
}

.cloud-4 {
  top: 18%;
  left: 30%;
  width: 140px;
  height: 50px;
  background: radial-gradient(ellipse at 40% 50%, rgba(255,255,255,0.9) 0%, transparent 70%);
  animation: cloudDrift 22s linear infinite;
  animation-delay: -12s;
}

@keyframes cloudDrift {
  0% { transform: translateX(0) translateY(0); }
  50% { transform: translateX(30px) translateY(-8px); }
  100% { transform: translateX(0) translateY(0); }
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(180deg, transparent 0%, rgba(200, 220, 240, 0.3) 100%);
}

.wave::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23c9a962' fill-opacity='0.15' d='M0,160L48,144C96,128,192,96,288,90.7C384,85,480,107,576,133.3C672,160,768,192,864,197.3C960,203,1056,181,1152,165.3C1248,149,1344,139,1392,133.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E") no-repeat bottom;
  background-size: cover;
}

.wave-2::before {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23b8d4e8' fill-opacity='0.2' d='M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,181.3C1248,171,1344,181,1392,186.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E") no-repeat bottom;
  background-size: cover;
  bottom: 60px;
  height: 100px;
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c4a6e;
  margin: 0 0 8px;
  letter-spacing: 6px;
  text-shadow: 0 2px 4px rgba(74, 126, 184, 0.1);
}

.subtitle {
  font-size: 1rem;
  color: #6b8caa;
  margin: 0 0 48px;
  letter-spacing: 3px;
}

.entries {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 380px;
}

.entry-card {
  position: relative;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(201, 169, 98, 0.3);
  border-radius: 16px;
  padding: 20px 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
}

.entry-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(201, 169, 98, 0.05) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.entry-card:hover::before {
  opacity: 1;
}

.entry-card:hover {
  transform: translateY(-4px);
  border-color: rgba(201, 169, 98, 0.5);
  box-shadow: 0 16px 40px rgba(74, 126, 184, 0.12), 0 0 20px rgba(201, 169, 98, 0.1);
}

.entry-card.is-clicked {
  transform: scale(0.98);
}

.card-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 140px;
  height: 100%;
  background: linear-gradient(270deg, rgba(200, 220, 240, 0.3) 0%, transparent 100%);
  opacity: 0.5;
  transition: opacity 0.3s;
}

.entry-card:hover .card-bg {
  opacity: 0.8;
}

.team .card-bg {
  background: linear-gradient(270deg, rgba(74, 126, 184, 0.15) 0%, transparent 100%);
}

.traveler .card-bg {
  background: linear-gradient(270deg, rgba(107, 140, 170, 0.1) 0%, transparent 100%);
}

.card-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-wrapper {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4a7eb8, #6b9bc3);
  border-radius: 12px;
  font-size: 1.25rem;
  color: white;
  flex-shrink: 0;
  transition: transform 0.3s;
  box-shadow: 0 4px 12px rgba(74, 126, 184, 0.2);
}

.entry-card:hover .icon-wrapper {
  transform: scale(1.1) rotate(3deg);
}

.text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.entry-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2c4a6e;
  letter-spacing: 1px;
}

.entry-desc {
  font-size: 0.875rem;
  color: #8ba4c4;
}

.arrow {
  color: #c9a962;
  font-size: 1.125rem;
  transition: all 0.3s;
}

.entry-card:hover .arrow {
  transform: translateX(4px);
  color: #b8943f;
}

.footer {
  position: absolute;
  bottom: 30px;
  font-size: 0.75rem;
  color: #8ba4c4;
  letter-spacing: 1px;
}

.coming-soon {
  opacity: 0.6;
  cursor: not-allowed;
}

.coming-soon:hover {
  transform: none;
  border-color: rgba(201, 169, 98, 0.3);
  box-shadow: none;
}

.coming-soon:hover .card-bg {
  opacity: 0.5;
}

.coming-soon:hover .icon-wrapper {
  transform: none;
}

.coming-soon:hover .arrow {
  transform: none;
  color: #c9a962;
}

.coming-soon-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #c9a962, #e8d5a3);
  color: #5a4a2a;
  font-size: 0.625rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(201, 169, 98, 0.3);
}

@media (min-width: 640px) {
  .entries {
    flex-direction: row;
    max-width: 700px;
  }

  .entry-card {
    flex: 1;
  }

  .title {
    font-size: 3rem;
  }

  .subtitle {
    font-size: 1rem;
  }
}
</style>
